export function getUi() {
    return Object.freeze({
        pencil: 'Pencil',
        information: 'Information',
        checkmark: 'Checkmark',
        alert: 'Alert',
        chevronLeft: 'ChevronLeft',
        chevronRight: 'ChevronRight',
        chevronDown: 'ChevronDown',
        arrowBox: 'ArrowBox',
        arrowLeft: 'ArrowLeft',
        arrowRight: 'ArrowRight',
        cross: 'Cross',
        calendar: 'Calendar',
        circularArrows: 'CircularArrows',
        minusCenter: 'MinusCenter',
        trashCan: 'Trashcan',
        plusCircle: 'PlusCircle',
        arrowDownLine: 'ArrowDownLine',
        filter: 'Filter',
    });
}
